export const FORMAT_DATE = {
	FRONT: 'dd/MM/yyyy',
	WITH_HOUR: 'dd/MM/yyyy HH:mm',
	BASIC_DASH: 'yyyy-MM-dd',
};
